import { render, staticRenderFns } from "./activeRoom.vue?vue&type=template&id=e0c0637a&scoped=true"
import script from "./activeRoom.vue?vue&type=script&lang=js"
export * from "./activeRoom.vue?vue&type=script&lang=js"
import style0 from "./activeRoom.vue?vue&type=style&index=0&id=e0c0637a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0c0637a",
  null
  
)

export default component.exports